module.exports = "/assets/data/81c73fd252707bbf058d64daaa1e08c3-EC3R.data.json";